/** "TWO" wordmark: Inter 600, tight tracking, always Latin and LTR in both UI languages. */
export function Wordmark({
  className = '',
  size = 'md',
}: {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}) {
  const sizes = { sm: 'text-base', md: 'text-lg', lg: 'text-2xl' } as const;
  return (
    <span
      lang="en"
      dir="ltr"
      className={['font-semibold tracking-[-0.06em] text-ink', sizes[size], className].join(' ')}
    >
      TWO
    </span>
  );
}
